"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const objectMapper_1 = require("./objectMapper");
const react_1 = tslib_1.__importDefault(require("react"));
/**
 * A React HOC to map components
 *
 * Example 1:
 *
 * Material UI Button: <MUI.Button label="ABC" />
 * BlueBase BUtton: <BB.Components.Button>{label}</BB.Components.Button>
 *
 * So BB.Components.Button = componentMapper(MUI.Button, { label: children });
 *
 * @param Component
 * @param fields
 */
function componentMapper(Component, fields, options = {}) {
    return (props) => {
        const newProps = objectMapper_1.objectMapper(props, fields, options);
        return (options.render !== undefined)
            ? options.render(newProps, Component)
            : (react_1.default.createElement(Component, Object.assign({}, newProps)));
    };
}
exports.componentMapper = componentMapper;
